import { BaseTheme } from './BaseTheme';
import { ICometThemePalette } from './ICometThemePalette';
import { ISemanticStyleHelper } from './ISemanticStyleHelper';
import { ISemanticSiteNavStyles } from './nav/ISemanticSiteNavStyles';
import { CometThemeSiteHeaderStyles } from './site-header/CometThemeSiteHeaderStyles';
import { ISemanticSiteHeaderStyles } from './site-header/ISemanticSiteHeaderStyles';

export class CometThemeStyles implements ISemanticStyleHelper {
    private siteHeaderHeight = 56;
    private _siteHeaderStyles: ISemanticSiteHeaderStyles;
    constructor(
        private theme: BaseTheme,
        private cometPalette: ICometThemePalette
    ) {
        this._siteHeaderStyles = new CometThemeSiteHeaderStyles(this.theme, this.siteHeaderHeight, this.cometPalette);
    }
    get siteNavStyles(): ISemanticSiteNavStyles | undefined {
        return undefined;
    }
    get siteHeaderStyles(): ISemanticSiteHeaderStyles {
        return this._siteHeaderStyles;
    }
}
